module.exports = __webpack_public_path__ + "static/media/ER.26785513.png";